import { Input, InputGroup, InputLeftElement, InputProps } from "@chakra-ui/react";
import { Currency } from "../../../models/court-pricing/dto/court-pricing-rule.dto";
import CurrencyPicker from "./CurrencyPicker";

type Props = { currency: Currency; setCurrency: (newCurrency: Currency) => void; } & InputProps;
export default function PriceInput(props: Props) {
    const { currency, setCurrency, ...rest } = props;
    return (
        <InputGroup zIndex={100} minW="120px">
            <InputLeftElement w="auto" px={2}>
                <CurrencyPicker selectedCurrency={currency} onCurrencyChange={setCurrency} />
            </InputLeftElement>
            <Input
                {...rest}
                pl="60px"
            />
        </InputGroup>
    )
}
export function isPriceInputValid(inputValue:string){
    return /^\d+([.,]\d{1,2})?$/.test(inputValue);
}
